import React, { ReactNode } from 'react';
import styles from './assets/student-screen.module.scss';
import classNames from 'classnames';
import StudentsGrid from './components/StudentsGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import CreateStudentButton from './components/CreateStudentButton';
import AdminLayout from 'src/components/layout/RoleLayout';
import { IStudent } from 'src/types/student';
import Loader from '../../../../../../components/Loader';
import user from '../../../../../../services/user-auth';

export interface StateProps {
    data: Paginated<IStudent>;
    inProgress: boolean;
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
}

export interface OwnProps {
    dataToCsV: string[][];
}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class StudentsList extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
        //this.getData = this.getData.bind(this);
        this.state = {
            filters: {},
            dataToCsV: [
                [
                    'id',
                    'First Name',
                    'Last Name',
                    'Address',
                    'Attorney First name',
                    'Attorney Last name',
                    'Attorney Email',
                    'Status',
                ],
            ],
        };
    }

    public render(): ReactNode {
        const { data, getData, inProgress } = this.props;
        const userRole: Array<string> = user.getRoles();

        return (
            <AdminLayout>
                <div className={`${classNames('pageHeading')}`}>
                    <h2 className={`${classNames('pageHeadingTitle')}`}>
                        STUDENTS {data.totalCount ? '(' + data.totalCount + ')' : ''}
                    </h2>
                    {userRole.map((i: string) =>
                        i === 'ROLE_ADMIN' ? <CreateStudentButton key={i + 'crsb'} /> : null,
                    )}
                </div>
                {inProgress ? <Loader /> : null}
                <div className={classNames(styles.list)}>
                    <StudentsGrid data={data} getData={getData} getDataCsv={this.props.getDataCsv} />
                </div>
            </AdminLayout>
        );
    }
}

export default StudentsList;
